import { render, staticRenderFns } from "./MeetingRoomIndex.vue?vue&type=template&id=65267d64&scoped=true"
import script from "./MeetingRoomIndex.vue?vue&type=script&lang=js"
export * from "./MeetingRoomIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65267d64",
  null
  
)

export default component.exports